var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirutualClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    opacity: 0.947,
    d: "M55.3539 23.8705L54.6498 24.2188L54.6469 25.0042C54.6337 28.5945 54.5322 32.1803 54.3425 35.7618C53.9814 37.1955 53.1567 38.1583 51.7912 38.7438C43.5327 41.5585 35.3631 41.4224 27.2298 38.3354C26.3524 37.68 25.7712 36.8368 25.4658 35.7681L25.3899 30.4595L25.3118 24.9908L25.3004 24.1922L24.5757 23.8565C22.1821 22.7478 19.7948 21.6178 17.4143 20.4667C17.3027 20.3133 17.2774 20.2067 17.2717 20.1437C17.2662 20.0832 17.2712 19.9785 17.3404 19.8175C17.4164 19.7751 17.4946 19.7354 17.575 19.6985C24.9293 16.9298 32.2504 14.1203 39.5385 11.2701C39.8896 11.2678 40.2293 11.3236 40.5634 11.4378C47.8825 14.2039 55.1851 17.0118 62.471 19.8613C62.5251 19.9883 62.5304 20.0729 62.5275 20.1222C62.5239 20.1834 62.5013 20.2969 62.3814 20.4675C60.0277 21.5832 57.6852 22.7175 55.3539 23.8705ZM27.9446 25.4235L26.1494 24.5739L26.1314 26.5598C26.1051 29.4403 26.1314 32.3204 26.2099 35.1998L26.2143 35.3614L26.2591 35.5168C26.5653 36.5795 27.2326 37.4023 28.2074 37.925L28.3 37.9747L28.3995 38.0085C35.5019 40.4181 42.6702 40.5875 49.8689 38.5156C51.2843 38.2732 52.4297 37.5351 53.2252 36.336L53.405 36.065L53.4324 35.7409C53.6917 32.6735 53.7447 29.5958 53.5916 26.5085L53.4967 24.5948L51.7711 25.4277C48.0293 27.2337 44.276 29.02 40.5107 30.7865C40.1776 30.9013 39.8455 30.9365 39.4997 30.8929C35.644 29.0677 31.7923 27.2444 27.9446 25.4235Z",
    stroke: "#999999",
    strokeWidth: 2.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M39.5 20L31.5 27V43.5",
    stroke: "#999999",
    strokeWidth: 2.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M39.5 40.5V36",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M17.5 59.75V69.5H34L37.5 65.5H42.5L46 69.5H63V59.75M17.5 59.75V50H63V59.75M17.5 59.75H12M63 59.75H68.5",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 58,
    width: 4,
    height: 4,
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirutualClassroom);
export default __webpack_public_path__ + "static/media/virutual_classroom.1aeca1910a190279e96b8f670de4b8f4.svg";
export { ForwardRef as ReactComponent };